import React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import {calcCount} from './iput/src/helper';

export default class HostsTable2 extends React.Component {
    
    render() {
        const { selected } = this.props;
        return (
            <div style={{height:'200px',overflow:'auto'}}>
            <Table size="small" >
                <TableHead>
                    <TableRow>
                        <TableCell>Value</TableCell>
                        <TableCell align="right">Count</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.props.data.map(row => (
                        <TableRow key={row}
                            hover
                            selected={row === selected}
                            onClick={event => {
                                if (this.props.onSelect) {
                                    this.props.onSelect(row);
                                }
                            }}>
                            <TableCell component="th" scope="row">
                                {row}
                            </TableCell>
                            <TableCell align="right">{calcCount(row)}</TableCell>

                        </TableRow>
                    ))}
                </TableBody>
                
            </Table>
            </div>
        );
    }
}